module.exports = __webpack_public_path__ + "static/white_bg1-2f4d76ff539c95731db29d6a7a256919.svg";